"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.EValidationErrorTrads = void 0;
exports.EValidationErrorTrads = {
    isArray: "Vous devez sélectionner au moins une valeur.",
    isBoolean: "Ce champ est obligatoire.",
    isEnum: "Ce champ est obligatoire.",
    isInt: "Assurez-vous d'entrer un nombre entier, sans décimales.",
    isNotEmpty: "Ce champ ne doit pas être vide.",
    isNumber: "Ce champ est obligatoire. La valeur doit être un nombre.",
    isObject: "Ce champ est obligatoire.",
    isString: "Ce champ est obligatoire.",
    max: "Le nombre doit être inférieur ou égal à {{var1}}.",
    min: "Le nombre doit être supérieur ou égal à {{var1}}.",
    badCredentials: "Identifiants incorrects. Veuillez réessayer.",
    clientNotExists: "Le client n'existe pas.",
    clientSheetNotExists: "La fiche client n'existe pas.",
    oneClientSheetNotExists: "Une des fiches clients n'existe pas.",
    emailNotExists: "L'email n'existe pas.",
    isEmail: "Veuillez entrer une adresse e-mail valide.",
    bankAbaInvalid: "Saisissez les 9 chiffres du code ABA de la banque américaine.",
    isNumberString: "Ce champ est obligatoire. La valeur doit être numérique.",
    isPhoneNumber: "Veuillez entrer un numéro de téléphone valide.",
    isPositive: "Le nombre doit être positif.",
    maxLength: "La longueur du texte ne doit pas dépasser {{var1}} caractères.",
    mustBeInThePast: "Assurez-vous que la date est dans le passé.",
    mustBeInTheFuture: "Assurez-vous que la date est dans le futur.",
    counterSignatureRequired: "Ce dossier se transmet avec la signature de la société de gestion.",
    passwordNotMatch: "Les mots de passe ne correspondent pas",
    isStrongPassword: "Le mot de passe doit être plus complexe pour des raisons de sécurité.",
    pinCodeNotValid: "Le code PIN n'est pas correct.",
    productNotExists: "Le produit n'existe pas.",
    simulatorInvalidExposure: "Répartition invalide : libellés uniques et total maximal de 100 %.",
    productSubscribedNotExists: "Le produit souscrit n'existe pas.",
    roleNotExists: "Le rôle que vous avez sélectionné n'existe pas.",
    uniqueEmail: "Veuillez utiliser une adresse e-mail différente, celle-ci est déjà utilisée.",
    wrongPassword: "Le mot de passe que vous avez saisi est incorrect. Veuillez réessayer.",
    arrayNotEmpty: "Ce champ est obligatoire.",
    productSheetNotExists: "La fiche produit n'existe pas.",
    subscriberNotSame: "Le souscripteur doit être le même sur tous les produits",
    subscriptionNotExists: "La souscription n'existe pas.",
    match: "Les valeurs ne correspondent pas.",
    uniqueSiret: "Ce siret est déjà renseigné pour un autre cabinet.",
    officeNotExists: "Ce Cabinet n'existe pas",
    minLength: "La longueur du texte doit être d'au moins {{var1}} caractères.",
    isIBAN: "Le format de l'IBAN saisi est invalide",
    isDate: "Ce champ est obligatoire.",
    isBIC: "Le format du BIC saisi est invalide",
    isUuid: "L'identifiant du produit est invalide.",
    productNotAvailable: "Le produit n'est pas disponible",
    emailNotFound: "L'adresse e-mail que vous avez fournie n'est associée à aucun compte ou a été désactivée.\n\nSi vous pensez qu’il s’agit d’une erreur, veuillez nous contacter à backoffice@wenimmo.com",
    emailCaseSensitive: "L'adresse e-mail doit être en minuscules",
    percentageTotalMustBe100: "Le total doit être égal à 100% ou, si vous saisissez en euros, au montant total saisi.",
    fileNotExists: "Le fichier n'existe pas",
    notInAdequationWithInvestment: "La réponse apportée ne semble pas en adéquation avec l'investissement souhaité",
    mustIncludeBicOrIrppOrBnc: "Vous devez sélectionner au moins un des régimes fiscaux suivants: BIC, IRPP ou BNC",
    personUSmustBeFalse: "La personne ne doit pas être un citoyen américain",
    corporationNotExists: "La société n'existe pas",
    incompleteSubscriber: "Le dossier incomplet doit être complété avant toute nouvelle souscription.",
    legacyPaidSubscriptionReadOnly: "Cette opération reprise est verrouillée en lecture seule.",
    blockOperation: "Contacter Wenimmo, backoffice@wenimmo.com, pour cette opération",
    mustBeLessOrEqualChildren: "Le nombre d'enfants à charge doit être inférieur ou égal au nombre d'enfants",
    associationProfessionnelleNotExists: "L'association professionnelle n'existe pas",
    isSameEmailThanSpouse: "L'adresse e-mail doit être différente de celle du conjoint",
    isSamePhoneThanSpouse: "Le numéro de téléphone doit être différent de celui du conjoint",
    userNotExists: "L'utilisateur n'existe pas",
};
